import React, { useState } from "react";

const StarRating = ({ rating, onRatingChange, size = 6, interactive = true }) => {
  const [hoverRating, setHoverRating] = useState(0);

  const handleClick = (value) => {
    if (interactive && onRatingChange) {
      onRatingChange(value);
    }
  };

  const handleMouseEnter = (value) => {
    if (interactive) {
      setHoverRating(value);
    }
  };

  const handleMouseLeave = () => {
    if (interactive) {
      setHoverRating(0);
    }
  };

  // Ensure rating is a number
  const numericRating = parseInt(rating) || 0;
  const displayRating = hoverRating || numericRating;

  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          className={`transition-colors duration-150 ${
            interactive ? "cursor-pointer hover:scale-110" : "cursor-default"
          }`}
          onClick={() => handleClick(star)}
          onMouseEnter={() => handleMouseEnter(star)}
          onMouseLeave={handleMouseLeave}
          disabled={!interactive}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill={star <= displayRating ? "#fbbf24" : "#d1d5db"}
            className={`w-${size} h-${size} transition-colors duration-150`}
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.957a1 1 0 00.95.69h4.158c.969 0 1.371 1.24.588 1.81l-3.37 2.448a1 1 0 00-.364 1.118l1.286 3.957c.3.921-.755 1.688-1.54 1.118l-3.37-2.448a1 1 0 00-1.176 0l-3.37 2.448c-.784.57-1.838-.197-1.539-1.118l1.285-3.957a1 1 0 00-.364-1.118L2.98 9.384c-.783-.57-.38-1.81.588-1.81h4.158a1 1 0 00.95-.69l1.285-3.957z" />
          </svg>
        </button>
      ))}
      {interactive && (
        <span className="ml-2 text-sm text-gray-400">
          {displayRating > 0 ? `${displayRating} star${displayRating !== 1 ? 's' : ''}` : 'Rate this testimonial'}
        </span>
      )}
    </div>
  );
};

export default StarRating;